import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API, absUrl } from "@/lib/api";
import CardContent from "@/components/CardContent";
import { Loader2, Nfc } from "lucide-react";

export default function PublicCard() {
  const { id } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/cards/${id}`)
      .then(({ data }) => setCard(data))
      .catch(() => setError(true));
  }, [id]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white p-6 text-center">
        <Nfc size={40} className="mb-4 text-slate-600" />
        <p className="font-display text-xl font-bold">Carta non trovata</p>
        <p className="mt-1 text-sm text-slate-400">Questo link NFC non è più attivo.</p>
      </div>
    );
  }

  if (!card) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-950"><Loader2 className="animate-spin text-indigo-400" size={30} /></div>;
  }

  return (
    <div className="min-h-screen">
      <CardContent
        data={card}
        logoUrl={absUrl(card.logo_url)}
        qrUrl={`${API}/public/cards/${card.id}/qr.png`}
        vcardUrl={`${API}/public/cards/${card.id}/vcard`}
        interactive={true}
      />
    </div>
  );
}
